import server from '../../../../server'
import { vsName as CsvWriterName } from '../../../../../records/csv/csvWriter'

class OrderDetailsPartsController {
  constructor(
    $state,
    partServer,
    csvWriter
  ) {
    this.state = $state
    this.partServer = partServer
    this.csvWriter = csvWriter
  }

  edit() {
    this.state.go('^.itemsEdit')
  }

  export() {
    this.partServer.partOrderItemExport({
      PartOrderId: this.partOrder.Id
    }).then(result => {
      this.csvWriter.saveFile({
        content: result,
        filename: `PartOrder_${this.partOrder.InvoiceNumber}_Items.csv`
      })
    })
  }
}

OrderDetailsPartsController.$inject = [
  '$state',
  server.vsName,
  CsvWriterName
]

export default OrderDetailsPartsController